import React from 'react';
import { Divider } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import { gEnums } from '../../../enums/globalEnums';
import { settingsActionTypes } from '../../enums/itemActionTypes';
import { FetchButton } from './FetchButton';

const sats = settingsActionTypes

export const fetchButton_via = (fbProps, actionName) => {
  const { previewClicked, previewInfo, confirmation, handlePreviewClicked, handleItemHelp, reset } = fbProps
  return <FetchButton
    key={uniqueKey('vida', 'fb', actionName)}
    actionName={actionName}
    previewClicked={previewClicked}
    previewReady={(previewInfo || confirmation) ? true : false}
    handlePreview={handlePreviewClicked}
    handleItemHelp={handleItemHelp}
    handleReset={reset}
  />
}

/**
 * an object of actionButtons
 * each item in the array will be a menu item
 */
export const actionButtonsTypes = {
  homeActions: [sats.createClient],
  baseSettings: [sats.baseForms, sats.baseSettings, sats.currentSettings],
  clientCreate: [sats.createClient],
  clientActions: [sats.createEvent, sats.updateEventStatus, sats.deleteClient],
  clientToProd: [sats.pushClientToProduction],
  copy: [sats.copyViewItemSettingsToViews, sats.copyViewItemSettingsFromDatabase],
  deleteBucket: [sats.deleteBucket],
  eventActions: [sats.deleteEvent, sats.copyEvent],
  fixAllSettings: [sats.fixAllSettings],
  googleAction: [sats.updateDataFromGoogleData, sats.updateDataFromGoogleSheets, sats.updateSettingsFromGoogleSheets],
  help: [sats.createHelpDocument],
  homeSettings: [sats.backupAllSettings, sats.fixAllSettings, sats.updateAllPageItems],
  recreate: [sats.recreateEvent],
  registration: [sats.restoreSettingsFromRegistration],
  restore: [sats.restoreSettingsFromBackup, sats.restoreSettingsFromPaste],
  settingsAction: [sats.backupSettings, sats.convertSettingsToSeparate, sats.fixSettings, sats.transferSettings],
  // transfer: [sats.transferEventToProduction, sats.transferSettingsToProduction, sats.transferDataToProduction, sats.transferSettings],
}

/**
 * returns (via callback) the buttons for viType
 * @param {string} viType 
 * @param {object} fbProps fetch button props
 * @param {function} callback 
 */
export const getAppAreaActionButtons = (viType, fbProps, callback) => {
  const abs = []
  const abss = []
  switch (viType) {
    case gEnums.viewSettingTypes.appActions:
      buttons_appActions(abs, fbProps, abss)
      break;
    case gEnums.viewSettingTypes.googleActions:
      // buttons_googleActions(abs, fbProps)
      break;
    case gEnums.viewSettingTypes.settingsActions:
      buttons_settingsActions(abs, fbProps, abss)
      break;
    case gEnums.viewSettingTypes.baseSettings:
      buttons_settingsViewer(abs, fbProps, abss)
      break;
    default:
      break;
  }
  callback(abs, abss)
}

const ammendButtonGroup = (abs, btns, fbProps, caption, index) => {
  abs.push(<Divider key={uniqueKey('vida', 'd', index)} horizontal>{caption}</Divider>)
  ammendBtns(abs, btns, fbProps)
}

const ammendBtns = (abs, btns, fbProps) => {
  btns.forEach(btn => {
    abs.push(fetchButton_via(fbProps, btn))
  })
}

/**
 * loads abs with fetchButtons for the settingsView actions
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_settingsViewer = (abs, fbProps, abss) => {
  if (fbProps.isGlobal) {
    ammendButtonGroup(abs, actionButtonsTypes.baseSettings, fbProps, 'Settings Viewer', 10)
    abss.push({ caption: 'Settings Viewer', items: actionButtonsTypes.baseSettings })
    // abss.push(...actionButtonsTypes.baseSettings)
  }
}

/**
 * loads abs with fetchButtons for the settingsActions actions
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_settingsActions = (abs, fbProps, abss) => {

  const { appArea, isGlobal, allowResetSettings, allowCopySettings, viType } = fbProps

  if (isGlobal) {
    if (allowResetSettings) {

      ammendButtonGroup(abs, actionButtonsTypes.settingsAction, fbProps, appArea + ' Settings', 0)
      abss.push({ caption: appArea + ' Settings', items: actionButtonsTypes.settingsAction })

      if (appArea === gEnums.appAreaTypes.home) {
        ammendButtonGroup(abs, actionButtonsTypes.help, fbProps, appArea + ' Help', 1)
        abss.push({ caption: appArea + ' Help', items: actionButtonsTypes.settingsAction })
        // abss.push(...actionButtonsTypes.help)
      }

      ammendButtonGroup(abs, actionButtonsTypes.restore, fbProps, appArea + ' Restore App Settings', 2)
      // abss.push(...actionButtonsTypes.restore)
      abss.push({ caption: appArea + ' Restore App Settings', items: actionButtonsTypes.settingsAction })

      switch (fbProps.appArea) {
        case gEnums.appAreaTypes.event:
          ammendButtonGroup(abs, actionButtonsTypes.registration, fbProps, appArea + ' Registration', 3)
          abss.push(...actionButtonsTypes.registration)
          // abss.push({ caption: appArea + ' Registration', items: actionButtonsTypes.registration })
          break;
        default:
        // nothing
      }

      ammendButtonGroup(abs, actionButtonsTypes.deleteBucket, fbProps, appArea + ' Storage', 4)
      // abss.push(...actionButtonsTypes.deleteBucket)
      abss.push({ caption: appArea + ' Storage', items: actionButtonsTypes.deleteBucket })

    }
  }

  switch (appArea) {
    case gEnums.appAreaTypes.home:
      switch (viType) {
        case gEnums.viewSettingTypes.settingsActions:
          ammendButtonGroup(abs, actionButtonsTypes.homeSettings, fbProps, 'All Settings', 11)
          // abss.push(...actionButtonsTypes.homeSettings)
          abss.push({ caption: 'All Settings', items: actionButtonsTypes.homeSettings })
          // ammendButtonGroup(abs, actionButtons.serviceAccount, fbProps, 'URL')
          break;
        default:
        // nothing 
      }
      break;

    case gEnums.appAreaTypes.client:
      switch (viType) {
        case gEnums.viewSettingTypes.settingsActions:
          if (allowCopySettings) {
            ammendButtonGroup(abs, actionButtonsTypes.copy, fbProps, 'Copy', 12)
            abss.push({ caption: 'Copy', items: actionButtonsTypes.copy })
            // abss.push(...actionButtonsTypes.copy)
          }
          ammendButtonGroup(abs, actionButtonsTypes.fixAllSettings, fbProps, 'Fix Settings', 13)
          // abss.push(...actionButtonsTypes.fixAllSettings)
          abss.push({ caption: 'Fix Settings', items: actionButtonsTypes.fixAllSettings })
          break;
        default:
        // nothing
      }
      break;
    default:
    // nothing
  }
}

/**
 * loads abs with fetchButtons based on the appArea
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_appActions = (abs, fbProps, abss) => {

  const { appArea, allowResetSettings } = fbProps

  switch (appArea) {

    case gEnums.appAreaTypes.home:
    case gEnums.appAreaTypes.clients:
      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtonsTypes.clientCreate, fbProps, appArea + ' Actions', 14)
        abss.push({ caption: appArea + ' Actions', items: actionButtonsTypes.clientCreate })
        // abss.push(...actionButtonsTypes.clientCreate)
      }
      break;

    case gEnums.appAreaTypes.client:
      ammendButtonGroup(abs, actionButtonsTypes.clientActions, fbProps, appArea + ' Actions', 15)
      abss.push({ caption: appArea + ' Actions', items: actionButtonsTypes.clientActions })
      // abss.push(...actionButtonsTypes.clientActions)
      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtonsTypes.clientToProd, fbProps, appArea + ' Production', 16)
        abss.push({ caption: appArea + ' Production', items: actionButtonsTypes.clientToProd })
        // abss.push(...actionButtonsTypes.clientToProd)
      }
      break;

    case gEnums.appAreaTypes.event:

      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtonsTypes.eventActions, fbProps, appArea + ' Delete', 16)
        abss.push({ caption: appArea + ' Delete', items: actionButtonsTypes.eventActions })
        // abss.push(...actionButtonsTypes.eventActions)
      }
      break;
    default:
    // nothing 
  }
}
